export const userInterestsPath = "/user-interests";
